import { render, staticRenderFns } from "./DesignModal.vue?vue&type=template&id=a59cbac4&scoped=true&"
import script from "./DesignModal.vue?vue&type=script&lang=js&"
export * from "./DesignModal.vue?vue&type=script&lang=js&"
import style0 from "./DesignModal.vue?vue&type=style&index=0&id=a59cbac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59cbac4",
  null
  
)

export default component.exports